const MONTH_DISPLAY_LENGTH = 2;

export const formatExpirationDate = (month: number, year: number): string => {
  const paddedMonth = String(month).padStart(MONTH_DISPLAY_LENGTH, '0');

  return `${paddedMonth}/${year}`;
};
